import * as colors from './colors'

export { colors }
